import Immutable from "seamless-immutable";
import { SET_INTEGRATIONS, SET_INTEGRATION_BUSY, LOGOUT, IMPERSONATE_USER, STOP_IMPERSONATE_USER } from "../actions/Types";

const initialState = Immutable({
  data: {},
  subscribedZips: [],
  fetched: false,
  busy: false
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_INTEGRATIONS:
      return Immutable.merge(state, {
        data: action.data,
        subscribedZips: action.subscribedZips,
        fetched: true
      });
    case SET_INTEGRATION_BUSY:
      return Immutable.merge(state, { busy: action.busy });
    case IMPERSONATE_USER:
    case STOP_IMPERSONATE_USER:
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
